import { c as _c } from "react/compiler-runtime";
import { logger } from "@justhome/common";
import { Maybe } from "@lib/generated/graphql";
interface StrapiComponent {
  __typename?: Maybe<string>;
  staticData?: any;
}
type DynamicZoneTypename<T extends StrapiComponent> = Extract<T["__typename"], string>;
export type DynamicZoneComponents<T extends StrapiComponent> = Record<DynamicZoneTypename<T>, any>;
export type DynamicZoneStaticComponentData<T extends StrapiComponent> = Record<DynamicZoneTypename<T>, any>;
const DynamicZone = t0 => {
  const $ = _c(5);
  const {
    component,
    components,
    staticComponentData,
    index
  } = t0;
  if (!component) {
    return null;
  }
  const typename = component.__typename as DynamicZoneTypename<T>;
  const Component = components[typename];
  const staticData = staticComponentData?.[typename];
  if (!Component) {
    logger.warn(`Unknown component ${component.__typename}.`);
    return null;
  }
  let t1;
  if ($[0] !== Component || $[1] !== component || $[2] !== index || $[3] !== staticData) {
    t1 = <Component data={component} index={index} staticData={staticData} />;
    $[0] = Component;
    $[1] = component;
    $[2] = index;
    $[3] = staticData;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default DynamicZone;